export default "__VITE_ASSET__e5483ab0__"